import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface SubsiteConfig {
  name: string;
  api_token: string;
}

export interface SubsiteConfigListInfor {
  errors: unknown;
  linhVucDieutra: SubsiteConfig;
  isAuthenticated: boolean;
}

@Module
export default class SubsiteConfigModule
  extends VuexModule
  implements SubsiteConfigListInfor
{
  errors = {};
  linhVucDieutra = {} as SubsiteConfig;
  isAuthenticated = !!JwtService.getToken();

  get SubsiteConfigs() {
    return this.subsiteConfigListData;
  }

  get SubsiteConfigDetail() {
    return this.subsiteConfigDetailData;
  }

  @Mutation
  [Mutations.SUBSITE_CONFIG_LIST_DATA](SubsiteConfigs) {
    this.subsiteConfigListData = SubsiteConfigs;
  }

  @Mutation
  [Mutations.SUBSITE_CONFIG_DETAIL_DATA](SubsiteConfig) {
    this.subsiteConfigDetailData = SubsiteConfig;
  }

  @Action
  [Actions.SUBSITE_CONFIG_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("subsite_config/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.SUBSITE_CONFIG_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.SUBSITE_CONFIG_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("subsite_config", payload)
        .then((data) => {
          this.context.commit(Mutations.SUBSITE_CONFIG_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.SUBSITE_CONFIG_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/subsite_config",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.SUBSITE_CONFIG_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.SUBSITE_CONFIG_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/subsite_config", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.SUBSITE_CONFIG_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.SUBSITE_CONFIG_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/subsite_config",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.SUBSITE_CONFIG_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
